<template>
    <div id="cargador-deptos">
<!--        <p>Cant deptos: {{ deptos.length }}</p>-->
        <p>Feature: {{ props.departamen }} - {{ props.personas}} habs. - {{ props.viviendas_}} vivs.</p>
        <p>Proporción hombres: {{ props.prop_hombres }} -  hombres: {{ props.prop_mujeres }} - Semáforo: {{ props.semaforo }}</p>
    </div>
</template>

<script>
    import departamentosOrig from "@/data/deptos_baires.geojson";

    export default {
        name: "CargadorDepartamentos",
        props: {
            'featureClicked': {
                type: Object
            }
        },
        computed: {
            props() {
                return this.featureClicked && this.featureClicked.properties ? this.featureClicked.properties : '---';
            }
        },
        data: function () {
            return {
                deptos: []
            }
        },
        mounted() {
            let departamentos = JSON.parse(departamentosOrig);
            // console.log(departamentos);

            let deptos = [];
            departamentos.features.forEach(function (departamento) {
                let props = departamento.properties;
                props['prop_hombres'] = +props.varones / +props.personas;
                props['prop_mujeres'] = +props.mujeres / +props.personas;
                props['semaforo'] = props.link % 3;

                console.log(departamento);
                deptos.push(departamento);
            });
            this.deptos = deptos;
            this.$emit('departamentos-cargados', this.deptos);
        },
        methods: {}
    }
</script>

<style scoped>
    #cargador-deptos {
        height: 60px;
    }
</style>